<template>
    <b-card no-body class="mb-0" >
        <div class="m-2">
            <b-row>
                <b-col
                    cols="12"
                    md="12"
                    class="mb-1 mb-md-0"
                >
                    <b-form @submit.prevent>
                        <b-row>

                        <!-- Avatar -->
                        <b-col cols="12" md="6" class="mt-2 mb-3">
                            <b-form-group
                            label="Avatar"
                            label-for="vi-avatar"
                            >
                                <b-avatar
                                    ref="previewEl"
                                    :src="datas.avatar"
                                    size="90px"
                                    rounded
                                    class="inline-block"
                                />

                                <input @change="handleImage" class="custom-input inline-block ml-2" type="file" accept="image/jpeg" ></input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                        </b-col>

                        <!-- nom -->
                        <b-col cols="12" md="6">
                            <b-form-group
                            label="Nom"
                            label-for="vi-nom"
                            >
                            <b-input-group class="input-group-merge">
                                <b-input-group-prepend is-text>
                                </b-input-group-prepend>
                                <b-form-input
                                id="vi-nom"
                                v-model="datas.nom"
                                placeholder="Nom complet"
                                required
                                />
                            </b-input-group>
                            </b-form-group>
                        </b-col>

                        <!-- prénom -->
                        <b-col cols="12"  md="6">
                            <b-form-group
                            label="Prénom"
                            label-for="vi-prenom"
                            >
                                <b-input-group class="input-group-merge">
                                    <b-input-group-prepend is-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                    id="vi-prenom"
                                    v-model="datas.prenom"
                                    placeholder="Prénom"
                                    required
                                    />
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <!-- téléphone -->
                        <b-col cols="12"  md="6">
                           <b-input-group>
                            <b-input-group-prepend is-text>
                                Téléphone (+33)
                                </b-input-group-prepend>
                                <cleave
                                    id="phone"
                                    v-model="datas.phone"
                                    class="form-control"
                                    :raw="false"
                                    :options="phone"
                                    placeholder="01 23 45 67 89"
                                />
                            </b-input-group>
                        </b-col>

                        <!-- password -->
                        <b-col cols="12"  md="6">
                            <b-form-group
                            label="Mot de passe"
                            label-for="vi-password"
                            >
                            <b-input-group>
                                <b-form-input
                                id="basic-password"
                                :type="passwordFieldType"
                                v-model="password"

                                placeholder="Mot de passe"
                                />
                                <b-input-group-append is-text>
                                <feather-icon
                                    :icon="passwordToggleIcon"
                                    class="cursor-pointer"
                                    @click="togglePasswordVisibility"
                                />
                                </b-input-group-append>
                            </b-input-group>
                            </b-form-group>
                        </b-col>

                        <!-- Afficher prix catalogue -->
                        <b-col cols="12"  md="4" class="mt-2 mb-3">
                            <b-form-group
                            label="Afficher les prix dans les fiches produits"
                            label-for="vi-password"
                            >
                                <b-form-checkbox
                                    v-model="datas.showprice"
                                    value=true
                                    unchecked-value=false
                                    class="custom-control-primary mt-2"
                                >
                                    Activer
                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12"  md="4" class="mt-2 mb-3">
                            <b-form-group
                                label="Afficher les frais de port"
                                label-for="vi-password"
                                >
                                    <b-form-checkbox
                                        v-model="datas.showfraisport"
                                        value=true
                                        unchecked-value=false
                                        class="custom-control-primary mt-2"
                                    >
                                        Activer
                                    </b-form-checkbox>
                                </b-form-group>
                        </b-col>

                        <b-col cols="12"  md="4" class="mt-2 mb-3">
                            <b-form-group
                                label="Afficher les produits de toutes les saisons"
                                label-for="vi-password"
                                >
                                    <b-form-checkbox
                                        v-model="datas.showallsaison"
                                        value=true
                                        unchecked-value=false
                                        class="custom-control-primary mt-2"
                                    >
                                        Activer
                                    </b-form-checkbox>
                                </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12">
                            <h4>Configuration envoi de mail</h4>
                        </b-col>
                        <!-- email -->
                        <b-col cols="12"  md="6" class="mt-2 mb-3">
                            <b-form-group
                            label="Email"
                            label-for="vi-email"
                            >
                            <b-input-group class="input-group-merge">
                                <b-input-group-prepend is-text>
                                </b-input-group-prepend>
                                <b-form-input
                                id="vi-email"
                                v-model="datas.email"
                                placeholder="Email"
                                type="email"
                                required
                                />
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12"  md="6" class="mt-2 mb-3"></b-col>
                        <!-- serveur smtp -->
                        <b-col cols="12"  md="6" class="mt-2 mb-3 confmail">
                            <b-form-group
                            label="Serveur SMTP"
                            label-for="vi-srvsmtp"
                            >
                            <b-input-group class="input-group-merge">
                                <b-input-group-prepend is-text>
                                </b-input-group-prepend>
                                <b-form-input
                                id="vi-srvsmtpl"
                                v-model="datas.srvsmtp"
                                placeholder="Email"
                                type="text"
                                />
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <!-- port-->
                        <b-col cols="12"  md="3" class="mt-2 mb-3 confmail">
                            <b-form-group
                            label="Port SMTP"
                            label-for="vi-portsmtp"
                            >
                            <b-input-group class="input-group-merge">
                                <b-input-group-prepend is-text>
                                </b-input-group-prepend>
                                <b-form-input
                                id="vi-portsmtp"
                                v-model="datas.portsmtp"
                                placeholder="Port SMTP"
                                type="number"
                                />
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <!-- ssl -->
                        <b-col cols="12"  md="3" class="mt-2 mb-3 confmail">
                            <b-form-group
                            label="SSL"
                            label-for="vi-sllsmtp"
                            >
                                <b-form-checkbox
                                    v-model="datas.smtpsll"
                                    value=true
                                    unchecked-value=false
                                    class="custom-control-primary mt-2"
                                >
                                    Activer
                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>
                        <!-- login -->
                        <b-col cols="12"  md="6" class="confmail">
                            <b-form-group
                            label="Nom d'utilisateur de messagerie"
                            label-for="vi-loginsmtp"
                            >
                            <b-input-group class="input-group-merge">
                                <b-input-group-prepend is-text>
                                </b-input-group-prepend>
                                <b-form-input
                                id="vi-loginsmtp"
                                v-model="datas.loginsmtp"
                                placeholder="Nom d'utilisateur"
                                type="text"
                                />
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <!-- password -->
                        <b-col cols="12"  md="6" class="confmail">
                            <b-form-group
                            label="Mot de passe de messagerie"
                            label-for="vi-passwordsmtp"
                            >
                            <b-input-group>
                                <b-form-input
                                id="vi-passwordsmtp"
                                :type="passwordFieldType"
                                v-model="passwordsmtp"

                                placeholder="Mot de passe"
                                />
                                <b-input-group-append is-text>
                                <feather-icon
                                    :icon="passwordToggleIcon"
                                    class="cursor-pointer"
                                    @click="togglePasswordVisibility"
                                />
                                </b-input-group-append>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <!-- reset and submit -->
                        <b-col cols="12" class="mt-3">
                           <b-form-input
                                id="vi-id"
                                placeholder="ID"
                                v-model="datas.id"
                                hidden
                            />
                            <b-button
                            @click="submitForm()"
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            type="submit"
                            variant="primary"
                            class="mr-1">
                            Valider
                            </b-button>
                            <b-button
                                @click="$router.go(-1)"
                                variant="dark"
                                class="mr-1">
                                Retour
                            </b-button>
                        </b-col>
                        </b-row>
                    </b-form>
                </b-col>
        </b-row>
    </div>
</b-card>
</template>

<script>
import {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BInputGroup,
    BInputGroupPrepend,
    BLink,
    BCardHeader,
    BCardTitle,
    BTable,
    BAvatar,
    BFormFile,
    BFormSelect,
    BInputGroupAppend,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import useJwt from '@/auth/jwt/useJwt'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PouchDB from 'pouchdb'
import axios from 'axios'
import moment from 'moment'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.fr'

export default {
    components: {
        BCard,
        BRow,
        BCardHeader,
        BCardTitle,
        BTable,
        BCol,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BInputGroup,
        BInputGroupPrepend,
        BForm,
        BButton,
        BLink,
        BAvatar,
        BFormSelect,
        BInputGroupAppend,
        BFormFile,
        Cleave,
    },
    mixins: [togglePasswordVisibility],

    directives: {
        Ripple,
    },
    data() {
        return {
            avatarText,
            previewImage:null,
            datas: [],
            datasuser: [],
            password:"",
            file: null,
            role_options: [],
            selectedImage: '',
            localDB: new PouchDB(localStorage.getItem('database')),
            remoteDB: new PouchDB(localStorage.getItem('url')+'/'+localStorage.getItem('database')),
            remoteDBUser: '',
            phone: {
                phone: true,
                phoneRegionCode: 'FR',
            },
        };
    },
    computed: {
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
    },
    async created(){
        this.initialise()
    },
    methods: {
        async initialise() {
            // Lecture du document du user
            await axios.get(localStorage.getItem('url')+'/_users/org.couchdb.user:'+localStorage.getItem('user'),
                { withCredentials: true }
            ).then(response => {
                console.log('Axios response', response.data)
                this.datasuser = response.data
            }).catch(error=>{
                console.log('Axios error', error)
            })

            // Lecture des document sur l'index de recherhe type=commercial
            await this.localDB.find({selector: { type: 'commerciaux', id: this.datasuser._id }}).then(result => {
                console.log('commercial', result.docs[0])
                this.datas = result.docs[0]
            })
            .catch(error=>{
                console.log('Find error', error)
            })
        },
        async submitForm() {
            if(this.selectedImage.size >= 124000) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Taille d\'image',
                        icon: 'CoffeeIcon',
                        variant: 'danger',
                        text: 'Image trop loudre',
                    },
                })
            }
            else if(!this.datas.nom || !this.datas.prenom) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Champs obligatoires',
                        icon: 'CoffeeIcon',
                        variant: 'danger',
                        text: 'Merci de renseigner les champs obligatoires',
                    },
                })
            }
            else {
                // Vue 2: garantir l'ajout réactif du champ (et donc présent dans le payload)
                //this.$set(this.datas, 'id', this.datasuser.id)
                this.datas.passwordsmtp = btoa(this.passwordsmtp)
                this.datas.datemodif =  moment().format('YYYY-MM-DDTHH:mm:ss')
                console.log('DATAS (payload PUT)', this.datas)
                // update profile user
                await this.localDB.put(this.datas, (err, response) => {
                    if (err) {
                        console.log('errvalidation', err);
                    } else {
                        this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: 'Profile enregistrée',
                            icon: 'CoffeeIcon',
                            variant: 'success',
                            text: 'Votre profile a été enregistré',
                        },
                        })
                    }
                })

                // Lecture des document sur l'index de recherhe type=commercial
                await this.localDB.find({selector: { type: 'commerciaux', id: 'org.couchdb.user:' + localStorage.getItem('user') }}).then(result => {
                    console.log('commercial', result.docs[0])
                    localStorage.removeItem('commercial')
                    localStorage.commercial = JSON.stringify(result.docs[0])
                })

                if(this.password != '') {
                    delete this.datasuser.password_scheme
                    delete this.datasuser.salt
                    delete this.datasuser.derived_key
                    delete this.datasuser.iterations
                    this.datasuser.password = this.password

                    console.log('this.datasuser', this.datasuser)

                    // update user
                    await axios.put('https://couchdb.placedusite.fr/_users/org.couchdb.user:'+localStorage.getItem('user'),
                        this.datasuser,
                        { withCredentials: true }
                    ).then(response => {
                        console.log('Axios response', response.data)
                    }).catch(error=>{
                        console.log('Axios error', error)
                    })
                }

                await this.localDB.sync(this.remoteDB)
                .on('complete', complete => {
                    this.$router.push({ path: '/' })
                })
                .on('error', err => {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                        title: 'Problème de synchronisation',
                        icon: 'CoffeeIcon',
                        variant: 'success',
                        text: 'Impossible de synchronisée la commande',
                        },
                    })
                    this.$router.push({ path: '/' })
                })

            }
        },
        handleImage(e) {
            this.selectedImage = e.target.files[0]; // get first file
            // console.log(this.selectedImage)
            if(this.selectedImage.size >= 124000) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Taille d\'aimge',
                        icon: 'CoffeeIcon',
                        variant: 'danger',
                        text: 'Image trop loudre',
                    },
                })
            } else {
                this.createBase64Image(this.selectedImage)
            }
        },
        createBase64Image(fileObject) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.datas.avatar = e.target.result;
                // console.log(this.datas.avatar)
            };
            reader.readAsDataURL(fileObject);
        },
    },
}
</script>

<style lang="scss">
    // .confmail {
    //     display: none;
    // }
</style>